import React from 'react';
import styles from './QuantitySelector.module.css';

const QuantitySelector = ({
  label,
  quantity,
  handleIncrement,
  handleDecrement,
  image,
  disabled = false,
  maxAvailable,
}) => {
  const renderButtons = () => {
    return (
      <div className='col-auto pl-0'>
        <div className={styles.quantityContainer}>
          {quantity > 0 && (
            <>
              <button className={`${styles.subtract}`} onClick={handleDecrement}>
                -
              </button>
            </>
          )}
          <button
            className={`${styles.add} ${maxAvailable === quantity ? styles.disabled : ''}`}
            onClick={handleIncrement}
            disabled={maxAvailable === quantity}
          >
            +
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className={`mt-2 ${disabled ? styles.disabled : ''}`}>
      <div className='row'>
        <div className={`col text-truncate pr-0`}>
          <div className={styles.container}>
            <div className='row m-0' style={{ height: '59px' }}>
              {image ? (
                <div className='col-auto my-auto pl-2 pr-0'>
                  <div className='position-relative'>{image}</div>
                </div>
              ) : null}

              <div
                className='col text-truncate my-auto'
                style={{ paddingLeft: '12px', paddingRight: '12px' }}
              >
                <div className={`text-truncate ${styles.label}`}>{label}</div>
              </div>

              <div className={`col-auto ${styles.quantity} pl-0 pr-2 my-auto`}>{quantity}</div>
            </div>
          </div>
        </div>
        {renderButtons()}
      </div>
    </div>
  );
};

export default QuantitySelector;
